import { useState, useEffect } from 'react';
import { authedApiFetch } from '../utils/Api';

export const useFeatureFlags = (tenant, flagKeys = []) => {
  const [flagStatuses, setFlagStatuses] = useState({});
  const [flagsLoading, setFlagsLoading] = useState(true);
  const [flagsError, setFlagsError] = useState(null);

  useEffect(() => {
    if (tenant?.id && flagKeys.length > 0) {
      const getFlagStatuses = async () => {
        try {
          setFlagsLoading(true);
          setFlagsError(null);
          
          const params = new URLSearchParams();
          params.append('tenant_id', tenant.id);
          flagKeys.forEach(key => params.append('flag_keys[]', key));
          
          const url = `/launchdarkly_flags?${params.toString()}`;
          const res = await authedApiFetch({ endpoint: url, method: 'GET' });
          setFlagStatuses(res?.statuses || {});
        } catch (error) {
          console.error('Error fetching feature flags:', error);
          setFlagsError(error);
        } finally {
          setFlagsLoading(false);
        }
      };
      
      getFlagStatuses();
    }
  }, [tenant?.id, flagKeys]);

  return {
    flagStatuses,
    flagsLoading,
    flagsError
  };
};
